export default __webpack_public_path__ + "assets/color.1b60fd.jpg";